import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackArrow from "../../components/BackArrow";
import { routes } from "../../helpers/constants";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { reqToGetRestaurantDetailsFromIDB } from "../../store/slice/indexedDBSlice";
import moment from "moment";
import { DataNotFound } from "../../components";
import { dataMessages } from "../../helpers/messages";
import { checkIsValidArray } from "../../helpers/commonFunction";

const CompanyItemList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { type, selectedRestaurant } = location.state || {};

  useEffect(() => {
    if (!selectedRestaurant || !selectedRestaurant?.restaurant_id) {
      navigate(routes.dashboard);
    }
  }, []);

  const { restaurantList, govermentMarketList, isRestaurantListIDBChecked } =
    useSelector(
      (state) => ({
        restaurantList: state.indexedDBReducer?.restaurantList,
        isRestaurantListIDBChecked:
          state.indexedDBReducer?.isRestaurantListIDBChecked,
        govermentMarketList: state.indexedDBReducer?.govermentMarketList,
      }),
      shallowEqual
    );

  useEffect(() => {
    if (!isRestaurantListIDBChecked) {
      dispatch(reqToGetRestaurantDetailsFromIDB({}));
    }
  }, [restaurantList, govermentMarketList, isRestaurantListIDBChecked]);

  // CURRENT SELECTED RESTAURANT
  const currSRestaurant = useMemo(() => {
    const newRestaurantList =
      type === "COMPANY" || type === "cReports"
        ? restaurantList
        : govermentMarketList;

    if (!checkIsValidArray(newRestaurantList)) {
      return selectedRestaurant;
    }

    const sRestaurant = newRestaurantList.find(
      (item) => item.id === selectedRestaurant.id
    );

    return sRestaurant || selectedRestaurant;
  }, [restaurantList, govermentMarketList]);

  const handleNavigate = (resLocation, item, isCompleted) => {
    if ((type === "COMPANY" || type === "GOVERMENT") && !isCompleted) {
      if (Array.isArray(item?.sub_items)) {
        navigate(routes.companyItemDetails, {
          state: {
            ...location.state,
            selectedItem: item,
            selectedLocation: resLocation,
            selectedRestaurant: currSRestaurant,
            showUpload: type === "GOVERMENT",
          },
        });
      }
    } else if ((type === "COMPANY" || type === "GOVERMENT") && isCompleted) {
      navigate(routes.companyReportStages, {
        state: {
          ...location.state,
          realType: type,
          selectedRestaurant: currSRestaurant,
          selectedItem: item,
          selectedLocation: resLocation,
          showUpload: type === "GOVERMENT",
        },
      });
    } else {
      navigate(routes.reportItemDetails, {
        state: {
          ...location.state,
          selectedItem: item,
          selectedLocation: resLocation,
          selectedRestaurant: currSRestaurant,
        },
      });
    }
  };

  const getFullItemBGColor = (group) => {
    if (!Array.isArray(group?.items) || group.items.length === 0) {
      return "";
    }

    const allSubItems = group.items.flatMap((item) => item?.sub_items || []);

    if (allSubItems.length === 0) {
      return "";
    }

    const isAllGreen = allSubItems.every(
      (sub) => (sub?.item_report?.length || 0) >= 3
    );

    const isAllEmpty = allSubItems.every(
      (sub) => (sub?.item_report?.length || 0) === 0
    );

    if (isAllGreen) {
      return "bg-green";
    }

    if (isAllEmpty) {
      return "";
    }

    return "";
  };

  const getItemBGColor = (item) => {
    if (!checkIsValidArray(item?.sub_items)) {
      return { isComplete: false, className: "" };
    }

    if (item?.sub_items?.every((sub) => sub?.item_report?.length >= 3)) {
      return { isComplete: true, className: "bg-green" };
    } else if (
      item?.sub_items?.every((sub) => sub?.item_report?.length === 0)
    ) {
      return { isComplete: false, className: "" };
    } else {
      return { isComplete: false, className: "bg-yellow" };
    }
  };

  return (
    <div className="tcl-raffles-makati-page">
      <div
        className={`tcl-raffles-makati-wrapper ${
          type === "gReports" || type === "cReports"
            ? "tcl-raffles-makati-report-wrapper"
            : ""
        }`}
      >
        <BackArrow
          handleClick={() =>
            navigate(
              type === "COMPANY"
                ? routes.company
                : type === "GOVERMENT"
                ? routes.goverment
                : routes.reports,
              {
                state: { ...location.state },
              }
            )
          }
        />
        <div className="tcl-raffles-makati-content">
          {(type === "COMPANY" || type === "GOVERMENT") && (
            <div className="tcl-raffles-makati-text">
              <h2>
                To do's <br /> in <b>{currSRestaurant?.name}</b>
              </h2>
              <p className="date">
                Date Today: {moment().format("MMM DD, YYYY")}
              </p>
            </div>
          )}
          {(type === "gReports" || type === "cReports") && (
            <button className="app-btn btn btn-green tcl-report-btn mt-0">
              {currSRestaurant?.name}
            </button>
          )}
          {!Array.isArray(currSRestaurant?.location) ||
          currSRestaurant?.location?.length === 0 ? (
            <DataNotFound name={dataMessages.noItems} />
          ) : (
            <div className="tcl-raffles-makati-table">
              <table className="items-table">
                <thead className="tc_custom_table_header">
                  <tr>
                    <th>No</th>
                    <th>ITEMS</th>
                    <th>Location</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(currSRestaurant?.location) &&
                    currSRestaurant?.location?.map((group, groupIndex) => {
                      return group.items.map((item, itemIndex) => {
                        const { className, isComplete } = getItemBGColor(item);
                        return (
                          <tr
                            key={`${groupIndex}-${itemIndex}`}
                            className={getFullItemBGColor(group)}
                          >
                            {itemIndex === 0 && (
                              <>
                                <td rowSpan={group.items.length}>
                                  {groupIndex + 1}
                                </td>
                                <td
                                  className={`item-link ${className}`}
                                  onClick={() =>
                                    handleNavigate(group.name, item, isComplete)
                                  }
                                >
                                  {item.name}
                                </td>
                                <td rowSpan={group.items.length}>
                                  {group.name}
                                </td>
                              </>
                            )}
                            {itemIndex > 0 && (
                              <td
                                className={`item-link ${className}`}
                                onClick={() =>
                                  handleNavigate(group.name, item, isComplete)
                                }
                              >
                                {item.name}
                              </td>
                            )}
                          </tr>
                        );
                      });
                    })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyItemList;
